export enum OrderDiscriminatorEnum {
  PURCHASE = 'PURCHASE',
  SALE = 'SALE',
  PURCHASE_BROKERAGE_SALE = 'PURCHASE_BROKERAGE_SALE',
  PURCHASE_BROKERAGE_FEES = 'PURCHASE_BROKERAGE_FEES',
}
